import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品',
    links: [
      { label: '首页', to: '/' },
      { label: '电影', to: '/category/dianying' },
      { label: '电视剧', to: '/category/dianshiju' },
      { label: '综艺', to: '/category/zongyi' },
      { label: '动漫', to: '/category/dongman' },
    ],
  },
  support: {
    title: '支持',
    links: [
      { label: '常见问题', to: '/#faq' },
      { label: '关于我们', to: '/about' },
      { label: '联系我们', to: '/about#contact' },
      { label: '使用条款', to: '/about' },
    ],
  },
  company: {
    title: '公司',
    links: [
      { label: '品牌介绍', to: '/about' },
      { label: '用户口碑', to: '/about#reputation' },
      { label: '加入我们', to: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-xl font-bold text-foreground-950">超碰在线</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              超碰在线是领先的免费视频平台，提供海量高清视频资源，极速加载、流畅播放，无需注册即可畅享。
            </p>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">{section.title}</h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 超碰在线. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" aria-label="哔哩哔哩">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}